import script from "./GlobalOps.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalOps.vue?vue&type=script&setup=true&lang=js"

import "./GlobalOps.vue?vue&type=style&index=0&id=e1659a86&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1659a86"]])

export default __exports__